import type { Logger } from '@seek/logger';

export const createClientLogger = () => {
  const logger = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    debug: (obj: unknown, msg?: string, ...args: any[]) => {
      // eslint-disable-next-line no-console
      console.debug(obj || msg, msg || args);
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error: (obj: unknown, msg?: string, ...args: any[]) => {
      // eslint-disable-next-line no-console
      console.error(obj || msg, msg || args);
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    fatal: (obj: unknown, msg?: string, ...args: any[]) => {
      // eslint-disable-next-line no-console
      console.error(obj || msg, msg || args);
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    info: (obj: unknown, msg?: string, ...args: any[]) => {
      // eslint-disable-next-line no-console
      console.info(obj || msg, msg || args);
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    trace: (obj: unknown, msg?: string, ...args: any[]) => {
      // eslint-disable-next-line no-console
      console.trace(obj || msg, msg || args);
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    warn: (obj: unknown, msg?: string, ...args: any[]) => {
      // eslint-disable-next-line no-console
      console.warn(obj || msg, msg || args);
    },
  } as unknown as Logger;

  return logger;
};

export type { Logger } from '@seek/logger';
